import { Routes } from '@angular/router';
import { InvigilatorAuthGuard } from './guard/invigilator-auth.guard';
import { ErrorPageComponent } from './site/error/error-page/error-page.component';
import { NotFoundComponent } from './site/not-found/not-found.component';

export const routes: Routes = [
  // { path: '', loadComponent: () => import('./site/home/home-page/home-page.component').then(m => m.HomePageComponent) },
  { path: '', loadChildren: () => import('./site/login/login.routes').then(m => m.routes) },
  { path: 'exam', loadChildren: () => import('./site/exam/exam.routes').then(m => m.routes), canLoad: [InvigilatorAuthGuard] },
  { path: 'error/:errorCode', component: ErrorPageComponent },
  { path: '**', component: NotFoundComponent }
];
